import { render, staticRenderFns } from "./CompanySetting.vue?vue&type=template&id=cf054b06"
import script from "./CompanySetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanySetting.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports